import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatDate(dateStr) {
  const date = new Date(dateStr);
  return date.toLocaleDateString('es-MX', { 
    weekday: 'short', 
    day: 'numeric', 
    month: 'short' 
  });
}

export function formatTime(timeStr) {
  const [hours, minutes] = timeStr.split(':');
  const h = parseInt(hours);
  const ampm = h >= 12 ? 'PM' : 'AM';
  const hour12 = h % 12 || 12;
  return `${hour12}:${minutes} ${ampm}`;
}

export function getStatusColor(status) {
  const colors = {
    available: 'bg-green-500',
    reserved: 'bg-amber-500',
    seated: 'bg-blue-500',
    finished: 'bg-teal-500',
    blocked: 'bg-slate-500',
    pending: 'bg-purple-500',
    confirmed: 'bg-green-500',
    cancelled: 'bg-red-500',
    no_show: 'bg-red-500',
    completed: 'bg-teal-500'
  };
  return colors[status] || 'bg-slate-500';
}

export function getTodayDate() {
  return new Date().toISOString().split('T')[0];
}

export function generateTimeSlots(startTime = "12:00", endTime = "23:00", interval = 30) {
  const slots = [];
  const [startH, startM] = startTime.split(':').map(Number);
  const [endH, endM] = endTime.split(':').map(Number);
  
  let current = startH * 60 + startM;
  const end = endH * 60 + endM;
  
  while (current <= end) {
    const h = Math.floor(current / 60);
    const m = current % 60;
    slots.push(`${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}`);
    current += interval;
  }
  
  return slots;
}
